import { render, staticRenderFns } from "./adminDetails.vue?vue&type=template&id=08a6f0c8&scoped=true"
import script from "./adminDetails.vue?vue&type=script&lang=js"
export * from "./adminDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a6f0c8",
  null
  
)

export default component.exports